<template>
    <div class="col-md-12">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form class="form" @submit.prevent="handleSubmit(submit)" autocomplete="off">
                <div class="col-md-12 row">
                    <div class="col-md-4">
                        <label for="">Ngày nhận việc <span class="text-danger">*</span></label>
                        <ValidationProvider vid="start_date" name="Ngày nhận việc"
                                            rules="required"
                                            v-slot="{ errors, classes }">
                            <el-date-picker id="start_date"
                                            format="dd-MM-yyyy"
                                            ref="start_date"
                                            name="start_date"
                                            value-format="dd-MM-yyyy"
                                            type="date"
                                            placeholder="Ngày nhận việc"
                                            @input="handleEndDate"
                                            v-model="dataGeneralWorking.start_date"
                                            style="width: 100%;"
                            ></el-date-picker>
                            <div class="text-danger text-danger" data-field="name" data-validator="notEmpty">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                        <label for="">Số tháng thử việc <span class="text-danger">*</span></label>
                        <ValidationProvider vid="probation_months" name="Số tháng thử việc"
                                            rules="required"
                                            v-slot="{ errors, classes }">
                            <input type="number" v-model="dataGeneralWorking.probation_months" class="form-control" @input="handleEndDate">
                            <div class="text-danger text-danger" data-field="name" data-validator="notEmpty">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                        <label for="">Ngày kết thúc thử việc <span class="text-danger">*</span></label>
                        <ValidationProvider vid="probation_end_date" name="Ngày kết thúc thử việc"
                                            rules="required"
                                            v-slot="{ errors, classes }">
                            <el-date-picker id="probation_end_date"
                                            format="dd-MM-yyyy"
                                            ref="probation_end_date"
                                            name="probation_end_date"
                                            value-format="dd-MM-yyyy"
                                            type="date"
                                            placeholder="Ngày kết thúc thử việc"
                                            v-model="dataGeneralWorking.probation_end_date"
                                            style="width: 100%;"
                            ></el-date-picker>
                            <div class="text-danger text-danger" data-field="name" data-validator="notEmpty">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="col-md-12 row mt-4">
                    <div class="col-md-4">
                        <label for="">Ngày bắt đầu chính thức <span class="text-danger">*</span></label>
                        <ValidationProvider vid="official_start_date" name="Ngày bắt đầu chính thức"
                                            rules="required"
                                            v-slot="{ errors, classes }">
                            <el-date-picker id="official_start_date"
                                            format="dd-MM-yyyy"
                                            ref="official_start_date"
                                            name="official_start_date"
                                            value-format="dd-MM-yyyy"
                                            type="date"
                                            placeholder="Ngày bắt đầu chính thức"
                                            v-model="dataGeneralWorking.official_start_date"
                                            style="width: 100%;"
                            ></el-date-picker>
                            <div class="text-danger text-danger" data-field="name" data-validator="notEmpty">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                        <label for="">Cơ chế thu nhập</label>
                        <input type="text" v-model="dataGeneralWorking.income_scheme" class="form-control">
                    </div>
                    <div class="col-md-4">
                        <label for="">Ngày bắt đầu góp vốn</label>
                            <el-date-picker id="equity_start_date"
                                            format="dd-MM-yyyy"
                                            ref="equity_start_date"
                                            name="equity_start_date"
                                            value-format="dd-MM-yyyy"
                                            type="date"
                                            placeholder="Ngày bắt đầu góp vốn"
                                            v-model="dataGeneralWorking.equity_start_date"
                                            style="width: 100%;"
                            ></el-date-picker>
                    </div>
                </div>
                <div class="col-md-12 row mt-4">
                    <div class="col-md-4">
                        <label for="">Mức lương thực tế theo vị trí level</label>
                            <input type="text" class="form-control" v-model="dataGeneralWorking.salary">
                    </div>
                    <div class="col-md-4">
                        <label for="">Mức lương cơ bản (BHXH)</label>
                            <input type="text" class="form-control" v-model="dataGeneralWorking.salary_social_insurance">
                    </div>
                    <div class="col-md-4">
                        <label for="">Lịch làm việc</label>
                        <el-select class="w-100" v-model="dataGeneralWorking.work_calendar" placeholder="Chọn lịch làm việc">
                            <el-option v-for="item in workCalendars" :key="item.id" :label="item.value"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-md-4">
                        <label for="">Giờ checkin</label>
                        <el-time-select
                            class="w-100"
                            v-model="dataGeneralWorking.check_in_time"
                            :picker-options="{
                                start: '06:00',
                                step: '00:15',
                                end: '23:30'
                              }"
                            placeholder="Chọn giờ checkin">
                        </el-time-select>
                    </div>
                    <div class="col-md-4">
                        <label for="">Giờ checkout</label>
                        <el-time-select
                            class="w-100"
                            v-model="dataGeneralWorking.check_out_time"
                            :picker-options="{
                                start: '06:00',
                                step: '00:15',
                                end: '23:30'
                              }"
                            placeholder="Chọn giờ checkout">
                        </el-time-select>
                    </div>
                    <div class="col-md-4 mt-1">
                        <label for="">Khối</label>
                        <el-select v-model="dataGeneralWorking.division_type" filterable class="w-100" placeholder="Khối"
                                   clearable>
                            <el-option v-for="item in blocks" :key="item.id" :label="item.name" :value="item.id">
                              <span style="float: left">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="col-md-12 mt-4">
                    <button :disabled="loading" class="btn bg-violet text-white waves-effect waves-themed"> <i v-if="loading" class="el-icon-loading"></i> Cập nhật thông tin </button>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import {GENERAL_WORKING_INFO, POST_GENERAL_WORKING_INFO} from "../../../../core/services/store/profile.module";
import {mapGetters, mapState} from "vuex";
import moment from "moment";

export default {
    name: "GeneralWorkingInfo",
    data() {
        return {
            loading: false,
            userId: this.$route.query.user_id,
            workCalendars: [
                {
                    id: 0,
                    value: 'Thứ 2 - Thứ 6'
                },
                {
                    id: 1,
                    value: 'Thứ 2 - Thứ 7'
                },
                {
                    id: 2,
                    value: 'Khác'
                }
            ],
            blocks: [
                {
                    id: 1,
                    name: 'BO trụ sở'
                },
                {
                    id: 2,
                    name: 'BO cơ sở'
                },
                {
                    id: 3,
                    name: 'Kinh doanh'
                },
                {
                    id: 4,
                    name: 'Giáo viên'
                }
            ]
        }
    },
    props: {
        dataGeneralWorking: {
            type: Object,
            default: () => { return {} }
        }
    },
    mounted() {
    },
    methods: {
        submit()
        {
            let payload = {
                id: this.userId,
                start_date: this.dataGeneralWorking.start_date,
                probation_months: this.dataGeneralWorking.probation_months,
                probation_end_date: this.dataGeneralWorking.probation_end_date,
                official_start_date: this.dataGeneralWorking.official_start_date,
                income_scheme: this.dataGeneralWorking.income_scheme,
                equity_start_date: this.dataGeneralWorking.equity_start_date,
                salary: this.dataGeneralWorking.salary,
                salary_social_insurance: this.dataGeneralWorking.salary_social_insurance,
                check_in_time: this.dataGeneralWorking.check_in_time,
                check_out_time: this.dataGeneralWorking.check_out_time,
                work_calendar: this.dataGeneralWorking.work_calendar,
                division_type: this.dataGeneralWorking.division_type
            }
            this.$store.dispatch(POST_GENERAL_WORKING_INFO, payload).then((res) => {
                if (res.error)
                {
                    return;
                }
                this.$message.success('Cập nhật thành công')
            });
        },
        handleEndDate()
        {
            if (!this.dataGeneralWorking.start_date || !this.dataGeneralWorking.probation_months)
            {
                return;
            }
            let days = this.dataGeneralWorking.probation_months * 30;
            let start_date = moment(this.dataGeneralWorking.start_date, "DD-MM-YYYY")
                .add(days, 'days');

            this.dataGeneralWorking.probation_end_date = start_date.format("DD-MM-YYYY")

            this.dataGeneralWorking.official_start_date = start_date.add(1, 'days').format("DD-MM-YYYY")
        },
    },
}
</script>

<style scoped>
.bg-violet {
    background-color: #5E00B6;
}
</style>